import "./modules/common";
import Vue from "vue";
import Vuelidate from "vuelidate";
import VueApp from "~/Scripts/new/vueApp";
import ContactForm from "~/Components/ContactForm.vue";

Vue.use( Vuelidate );

new VueApp( {
  name: "Contact",
  components: {
    ContactForm
  }
} );
